import { useState, useEffect, memo } from "react";
import style from "./../index.module.scss";
import styleUi from "./AddMember.module.scss";
import { CSSTransition } from 'react-transition-group';
import * as YStyled from "../../Styleds";
import FriendInfo from "../../comm/global/components/FriendInfo";
import CheckIcon from '@mui/icons-material/Check';

const AddMember = ({ setModalType, arg, addModalType }) => {
    const [inProp, setInProp] = useState(false);
    const [selectedUser, set_selectedUser] = useState([]);
    const [filterUser, set_filterUser] = useState([]);
    const [searchTerm, setSearchTerm] = useState("");

    useEffect(() => {
        setInProp(true);
    }, []);

    useEffect(() => {
        if (searchTerm === "") {
            set_filterUser(arg.users);
        } else {
            const filtered = arg.users.filter(user =>
                user.user_name.includes(searchTerm) || user.user_username.includes(searchTerm)
            );
            set_filterUser(filtered);
        }
    }, [searchTerm, arg.users]);

    const handleInputChange = (event) => {
        setSearchTerm(event.target.value);
    };

    return (
        <div className={style.modalBottom}>
            <CSSTransition in={inProp} timeout={{
                appear: 0,
                enter: 300,
                exit: 0,
            }} classNames={{
                enterActive: style.UpPageEnterActive,
                enterDone: style.UpPageEnterDone,
                exitActive: style.UpPageExit,
                exitDone: style.UpPageExitActive
            }}
            >
                <div className={`${style.UpPage}`} >
                    <CSSTransition in={inProp} timeout={{
                        appear: 0,
                        enter: 300,
                        exit: 0,
                    }} classNames={{
                        enterActive: style.UpPageEnterActive,
                        enterDone: style.UpPageEnterDone,
                        exitActive: style.UpPageExit,
                        exitDone: style.UpPageExitActive
                    }}
                        onExited={async () => {
                            await new Promise(resolve => requestAnimationFrame(resolve));
                            setModalType(prev => prev.filter(v => v.cls !== "AddMember"))
                        }}
                    >
                        <div className={`${style.UpPage} ${style.page}`} id="background" onClick={event => {
                            if (event.target.id == "background") {
                                //modalThrough 的話點不到 ，也不合理
                            }
                        }}>
                            <div className={styleUi.app}>
                                <div className={styleUi.headerBar}>
                                    <YStyled.Span size={17}>新增成員</YStyled.Span>
                                </div>
                                <div className={styleUi.view}>
                                    <div className={styleUi.subHeader}>
                                        <YStyled.Span size={15} onClick={async (e) => {
                                            const currentDomain = window.location.origin; // 获取当前的域名和协议，例如 "http://localhost:3000"
                                            const invitePath = `/invite.html?id=${arg.eventVo.events_id}`; // 你想要生成的路径
                                            const inviteLink = `${currentDomain}${invitePath}`; // 构造完整的邀请链接
                                            if (navigator.share) {
                                                try {
                                                    await navigator.share({
                                                        url: inviteLink // 你想要分享的网址
                                                    });
                                                    console.log('分享成功');
                                                } catch (error) {
                                                    console.log('分享失败', error);
                                                }
                                            } else {
                                                navigator.clipboard.writeText(inviteLink).then(() => {
                                                    alert('己複製連結');
                                                }).catch(err => {
                                                    console.error("複製到剪貼簿失敗：", err);
                                                });
                                            }
                                        }}>傳送邀請連結</YStyled.Span>
                                    </div>
                                    <div className={styleUi.searchBar}>
                                        <img src="./assets/ui/back.png" onClick={e => {
                                            setInProp(false);
                                        }} />
                                        <YStyled.Input
                                            placeholder="輸入名稱或id"
                                            value={searchTerm}
                                            onChange={handleInputChange}
                                        />
                                        {searchTerm !== "" &&
                                            <img src="./assets/ui/close_c.png" onClick={e => {
                                                setSearchTerm("");
                                            }} />
                                        }
                                    </div>
                                    {selectedUser.length > 0 &&
                                        <div className={styleUi.selectedUser}>
                                            {selectedUser.map((v, k) => {
                                                return <FriendInfo key={k} type={2} user={v} onDel={e => {
                                                    set_selectedUser(prev => prev.filter(user => user !== v));
                                                }} />
                                            })}
                                        </div>
                                    }
                                    <YStyled.Span size={17} style={{ alignSelf: "flex-start", padding: "1rem" }}>用戶</YStyled.Span>
                                    <div className={styleUi.list}>
                                        {
                                            filterUser.map((v, k) => {
                                                return <div className={styleUi.item} key={k}>
                                                    <FriendInfo user={v} type={1} />
                                                    <div className={`${styleUi.checkBox} ${selectedUser.includes(v) ? styleUi.selected : ""}`} onClick={e => {
                                                        if (selectedUser.includes(v) === false)
                                                            set_selectedUser(prev => [...prev, v]);
                                                        else
                                                            set_selectedUser(prev => prev.filter(user => user !== v));
                                                    }}>
                                                        <CheckIcon />
                                                    </div>
                                                </div>
                                            })
                                        }
                                    </div>
                                    <YStyled.BTN3 className={`${styleUi.btn} ${selectedUser.length > 0 ? "" : styleUi.disabled}`} onClick={e => {
                                        if(arg.onAdd)
                                            arg.onAdd(selectedUser)
                                        setInProp(false);
                                    }}>
                                        <YStyled.Span size={17}>邀請</YStyled.Span>
                                    </YStyled.BTN3>
                                </div>
                            </div>
                        </div>
                    </CSSTransition>
                </div>
            </CSSTransition>
        </div>
    );
}

export default memo(AddMember);
